import type { SVGProps } from 'react';
import * as React from 'react';
import { forwardRef, Ref } from 'react';

const SvgEdit = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 12 12"
    ref={ref}
    {...props}
  >
    <path
      fill="currentColor"
      d="M10.655 3.44 8.561 1.345a.75.75 0 0 0-1.061 0l-5.78 5.78a.74.74 0 0 0-.22.53V9.75a.75.75 0 0 0 .75.75h2.095a.74.74 0 0 0 .53-.22l5.78-5.78a.75.75 0 0 0 0-1.06m-6.31 6.31H2.25V7.656L6.375 3.53 8.47 5.625zM9 5.095 6.905 3 8.03 1.875l2.095 2.095z"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgEdit);
export default ForwardRef;
